module.exports = __webpack_public_path__ + "img/omg3.f3faee42.png";